var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductSetupGrayOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66668 1C9.46377 1 9.26379 1.08451 9.1123 1.24378L1.56636 9.17698L1.17935 10.8045L2.68003 10.41L10.2211 2.482C10.2963 2.40292 10.3572 2.3077 10.3992 2.20117C10.4411 2.0946 10.463 1.97959 10.463 1.86289C10.463 1.7462 10.4411 1.63118 10.3992 1.52462C10.3572 1.41809 10.2963 1.32286 10.2211 1.24378C10.1459 1.16475 10.058 1.10348 9.96315 1.06216C9.86835 1.02088 9.76768 1 9.66668 1ZM8.38772 0.554582C8.72246 0.202671 9.18195 0 9.66668 0C9.90615 0 10.1426 0.0496237 10.3624 0.145325C10.5821 0.240996 10.78 0.380498 10.9456 0.554582C11.1112 0.728613 11.2412 0.933877 11.3296 1.15805C11.4179 1.3822 11.463 1.62163 11.463 1.86289C11.463 2.10415 11.4179 2.34359 11.3296 2.56773C11.2412 2.79191 11.1112 2.99717 10.9456 3.1712L3.30674 11.2021C3.24277 11.2694 3.16133 11.3175 3.07155 11.3411L0.627109 11.9836C0.457202 12.0282 0.276324 11.9804 0.150646 11.8577C0.0249687 11.7349 -0.0270673 11.5552 0.0135749 11.3843L0.624686 8.81443C0.645121 8.7285 0.687958 8.64951 0.748837 8.5855L8.38772 0.554582ZM5.50001 11.5C5.50001 11.2239 5.72387 11 6.00001 11H11.5C11.7762 11 12 11.2239 12 11.5C12 11.7761 11.7762 12 11.5 12H6.00001C5.72387 12 5.50001 11.7761 5.50001 11.5Z",
    fill: "#666770"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductSetupGrayOutline);
export default __webpack_public_path__ + "static/media/productSetupGrayOutline.33f794a2804b627afb274dff1b2afeef.svg";
export { ForwardRef as ReactComponent };